import { Row, Col, Button, Table, Nav } from "react-bootstrap";
import useSWR, { mutate } from "swr";
import AuthenticatedWrapper from "../../components/wrapper";
import { fetcher, serverUrl, swrConfig } from "../../helpers/utility";
import { useNavigate } from "react-router-dom";
import variables from "../../styles/utils.module.scss";
import styles from "../../styles/provider.module.scss";
import { useCallback, useState } from "react";
import axios from "axios";
import { format, isToday } from "date-fns";
import { APPROVED, IN_REVIEW } from "../../helpers/constants";
import NavigationBack from "../../components/NavigationBack";
import BasicModal from "../../components/BasicModal";
import InputWithLabel from "../../components/inputWithLabel";
import InputReadOnly from "../../components/inputReadOnly";
import NoResultsTable from "../../components/NoResultsTable";

function AdminLocalAuthority({ user }) {
  const STEPS = {
    ACTIVE: "ACTIVE",
    IN_REVIEW: "IN_REVIEW",
    REJECTED: "REJECTED",
  };
  const navigate = useNavigate();
  const [step, setStep] = useState(STEPS.ACTIVE);
  const [modalConfig, setModalConfig] = useState(null);
  const [showModal, setShowModal] = useState(false);

  if (user?.staffUser === false) {
    window.location.href = "https://www.bplaced.co.uk";
  }

  const { data: localAuthorityData } = useSWR(
    `${serverUrl}/admin/local-authority`,
    fetcher,
    swrConfig
  );

  const active = useCallback(() => {
    if (localAuthorityData && localAuthorityData.localAuthorities?.length > 0) {
      let approved = localAuthorityData.localAuthorities?.filter((localAuthority) => {
        return localAuthority.status === "APPROVED";
      });

      return approved;
    } else {
      return [];
    }
  }, [localAuthorityData]);

  const pending = useCallback(() => {
    if (localAuthorityData && localAuthorityData.localAuthorities?.length > 0) {
      let unapproved = localAuthorityData.localAuthorities?.filter((localAuthority) => {
        return localAuthority.status === "IN_REVIEW";
      });

      return unapproved;
    } else {
      return [];
    }
  }, [localAuthorityData]);

  const rejected = useCallback(() => {
    if (localAuthorityData && localAuthorityData.localAuthorities?.length > 0) {
      let unapproved = localAuthorityData.localAuthorities?.filter((localAuthority) => {
        return localAuthority.status === "REJECTED";
      });

      return unapproved;
    } else {
      return [];
    }
  }, [localAuthorityData]);

  const showLocalAuthority = useCallback(({ localAuthority }) => {
    setModalConfig({
      title: `${localAuthority?.name}`,
      message: (
        <div>
          <InputReadOnly label={`Local authority`} type="text" value={localAuthority?.name} />
          <InputReadOnly
            label={`Joined`}
            type="text"
            value={localAuthority?.created ? format(localAuthority?.created, "dd/MM/yyyy") : null}
          />
          <InputReadOnly
            label={`Approved`}
            type="text"
            value={
              localAuthority?.approved
                ? `Yes on ${
                    localAuthority?.approvalDate
                      ? format(localAuthority?.approvalDate, "dd/MM/yyyy")
                      : "Unknown"
                  }`
                : `No`
            }
          />
        </div>
      ),
      show: showModal,
      close: hideModal,
      size: "lg",
      buttons: [
        {
          title: `Approve`,
          variant: `outline-primary`,
          onClick: async () => {
            console.log(`Approve`);
            await axios.put(`${serverUrl}/local-authority`, {
              _id: localAuthority?._id,
              approved: true,
              status: "APPROVED",
            });

            await mutate(`${serverUrl}/admin/local-authority`);

            hideModal();
          },
        },
        {
          title: `Reject`,
          variant: `outline-danger`,
          onClick: async () => {
            console.log(`Reject`);
            await axios.put(`${serverUrl}/local-authority`, {
              _id: localAuthority?._id,
              approved: false,
              status: "REJECTED",
            });

            await mutate(`${serverUrl}/admin/local-authority`);

            hideModal();
          },
        },
        {
          title: `Close`,
          variant: `outline-primary`,
          onClick: () => {
            console.log(`Close`);
            hideModal();
          },
        },
      ],
    });
    setShowModal(true);
  }, []);

  function hideModal() {
    setShowModal(false);
    setModalConfig(null);
  }

  return (
    <AuthenticatedWrapper user={user}>
      <NavigationBack />

      <div style={{ marginTop: "0px", padding: "10px 0px 15px" }}>
        <Nav variant="tabs" defaultActiveKey="/home">
          <Nav.Item>
            <Nav.Link
              onClick={() => {
                console.log(`Review`);
                setStep(STEPS.IN_REVIEW);
              }}
              active={step === STEPS.IN_REVIEW}
            >
              In Review
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link
              onClick={() => {
                console.log(`Active`);
                setStep(STEPS.ACTIVE);
              }}
              active={step === STEPS.ACTIVE}
            >
              Active
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link
              onClick={() => {
                console.log(`Rejected`);
                setStep(STEPS.REJECTED);
              }}
              active={step === STEPS.REJECTED}
            >
              Rejected
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Row style={{ marginTop: 15 }}>
          <Col lg={6}>
            {/* ACTIVE LA's */}
            {step === STEPS.ACTIVE ? (
              <Row style={{ marginTop: 0 }}>
                <Col lg={12}>
                  {active()?.length > 0 ? (
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th>Local authority</th>
                          <th style={{ width: "75px" }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {active().map((localAuthority) => {
                          return (
                            <tr
                              key={localAuthority._id}
                              onClick={() => {
                                showLocalAuthority({ localAuthority });
                              }}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <td>{localAuthority?.name}</td>
                              <td></td>
                            </tr>
                          );
                        })}

                        {active().length === 0 ? (
                          <tr>
                            <td>No results.</td>
                            <td></td>
                          </tr>
                        ) : null}
                      </tbody>
                    </Table>
                  ) : (
                    <NoResultsTable />
                  )}
                </Col>
              </Row>
            ) : null}

            {/* PENDING LA's */}
            {step === STEPS.IN_REVIEW ? (
              <Row>
                <Col lg={12}>
                  {pending()?.length > 0 ? (
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th>Local authority</th>
                          <th>Created</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pending().map((localAuthority) => {
                          return (
                            <tr
                              key={localAuthority._id}
                              onClick={() => {
                                showLocalAuthority({ localAuthority });
                              }}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <td>{localAuthority?.name}</td>
                              <td>
                                {isToday(localAuthority.created)
                                  ? "Today"
                                  : format(localAuthority.created, "dd/MM/yyyy")}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  ) : (
                    <NoResultsTable />
                  )}
                </Col>

                <Col lg={6} xl={5}></Col>
              </Row>
            ) : null}

            {/* Rejected LA's */}
            {step === STEPS.REJECTED ? (
              <Row>
                <Col lg={12}>
                  {rejected()?.length > 0 ? (
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th>Local authority</th>
                          <th>Created</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rejected().map((localAuthority) => {
                          return (
                            <tr
                              key={localAuthority._id}
                              onClick={() => {
                                showLocalAuthority({ localAuthority });
                              }}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <td>{localAuthority?.name}</td>
                              <td>
                                {isToday(localAuthority.created)
                                  ? "Today"
                                  : format(localAuthority.created, "dd/MM/yyyy")}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  ) : (
                    <NoResultsTable />
                  )}
                </Col>

                <Col lg={6} xl={5}></Col>
              </Row>
            ) : null}
          </Col>
        </Row>
      </div>

      <BasicModal
        title={modalConfig?.title}
        message={modalConfig?.message}
        show={showModal}
        close={hideModal}
        size={modalConfig?.size || "sm"}
        buttons={modalConfig?.buttons}
      />
    </AuthenticatedWrapper>
  );
}

export default AdminLocalAuthority;
